
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getMealMenuIntelligence"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"branches"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getDashboardExtendedData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"branches"},"value":{"kind":"Variable","name":{"kind":"Name","value":"branches"}}},{"kind":"Argument","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"mealIntelligence"},"value":{"kind":"BooleanValue","value":true}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mealMenu"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mealsSelected"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"previousMealsSelected"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"uniqueMeals"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"previousUniqueMeals"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mostSelected"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"leastSelected"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"avgRating"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"previousAvgRating"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"skipped"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"previousSkipped"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"skippedPct"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"daysWithReport"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"daysInRange"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"additionalMeals"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"previousAdditionalMeals"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totalCost"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totalRevenue"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"previousTotalCost"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"previousTotalRevenue"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"meals"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nameEn"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nameAr"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"categoryEn"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"categoryAr"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"selections"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"customers"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rating"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ratingCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cost"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"marginPct"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"modifyPct"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"trendPct"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":877}};
    doc.loc.source = {"body":"query getMealMenuIntelligence($branches: [String], $startDate: String, $endDate: String) {\n  getDashboardExtendedData(branches: $branches, startDate: $startDate, endDate: $endDate, mealIntelligence: true) {\n    mealMenu {\n      mealsSelected\n      previousMealsSelected\n      uniqueMeals\n      previousUniqueMeals\n      mostSelected\n      leastSelected\n      avgRating\n      previousAvgRating\n      skipped\n      previousSkipped\n      skippedPct\n      daysWithReport\n      daysInRange\n      additionalMeals\n      previousAdditionalMeals\n      totalCost\n      totalRevenue\n      previousTotalCost\n      previousTotalRevenue\n      meals {\n        nameEn\n        nameAr\n        categoryEn\n        categoryAr\n        selections\n        customers\n        rating\n        ratingCount\n        cost\n        value\n        marginPct\n        modifyPct\n        trendPct\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["getMealMenuIntelligence"] = oneQuery(doc, "getMealMenuIntelligence");
        
